import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db2a10bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Send a request to this user:", -1))

import { computed, ref } from 'vue'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { notImplemented } from '@/util/AppUtil'
import Modal from '@/util/Modal.vue'
import ProfileCard from '../ProfileCard.vue'
import ResearchGroupItem from '../researchgroups/ResearchGroupItem.vue'
import UserItem from '../users/UserItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DataGroupRequestTransferModal',
  props: {
    dataGroupId: {}
  },
  setup(__props: any) {

const props = __props;



const ownerIdRef = ref<string>()
const modalRef = ref<InstanceType<typeof Modal>>()

const dataGroupStore = useDataGroupStore()

const dataGroupRef = computed(() => dataGroupStore.getLoadedGroup(props.dataGroupId))
const groupTypeTextRef = computed(() => dataGroupRef.value?.isProfile ? 'profile' : 'tree')

async function requestTransferAsync() {
  try {
    notImplemented()
  }
  finally {
    modalRef.value?.reset()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    class: "request-transfer-modal",
    onOk: requestTransferAsync
  }, {
    title: _withCtx(() => [
      _createTextVNode("Change owner")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Transfer now")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(UserItem, {
        ref: "userSelectorRef",
        "user-id": dataGroupRef.value?.ownerId
      }, null, 8, ["user-id"]),
      _createElementVNode("label", null, "to transfer ownerhip of this " + _toDisplayString(groupTypeTextRef.value) + " to you:", 1),
      (dataGroupRef.value?.isProfile)
        ? (_openBlock(), _createBlock(ProfileCard, {
            key: 0,
            "show-profile-type": "",
            static: "",
            "person-id": dataGroupRef.value.startItemId
          }, null, 8, ["person-id"]))
        : (_openBlock(), _createBlock(ResearchGroupItem, {
            key: 1,
            "data-group-id": _ctx.dataGroupId
          }, null, 8, ["data-group-id"]))
    ]),
    _: 1
  }, 512))
}
}

})